import './Statement.css';

export default function Statement() {
  return (
    <section className="statement" id="about">
      <div className="statement-inner">
        <div className="statement-left reveal">
          <div className="statement-label">Philosophy</div>
          <p className="statement-quote">
            Most apps send your documents <em>somewhere.</em><br />
            TAGpdf has nowhere to send them.
          </p>
        </div>
        <div className="statement-right reveal">
          <p className="statement-body">
            TAGpdf uses a hybrid extraction system combining an on-device OCR engine
            with intelligent language detection.{' '}
            <strong>Hindi, English, or mixed-script documents</strong> are recognized,
            tagged, and indexed automatically. No cloud pipeline. No server round-trip.
            Just your device doing the work.
          </p>
          <div className="statement-rule" />
          <p className="statement-note">
            All processing runs in Dart isolates.<br />
            Main thread stays unblocked throughout.
          </p>
        </div>
      </div>
    </section>
  );
}
